import { setupHammerAction } from "./features/hammerAction";

document.addEventListener("DOMContentLoaded", () => {
  setupHammerAction();
});